import React, { useEffect } from "react";

import { connect } from "react-redux";
import { fetchMyReqsAsync } from "../../redux/reqs/reqs.actions";
import { createStructuredSelector } from "reselect";
import { selectMyReqs } from "../../redux/reqs/reqs.selectors";

import socket from "../../assets/socketConnection";
import ReqCardsList from "../ReqCardsList/ReqCardsList.container";

const MyReqsList = ({ fetchMyReqsAsync, selectMyReqs }) => {
  useEffect(() => {
    fetchMyReqsAsync(socket);

    // return () => {
    //     cleanup
    // }
  }, []);
  // console.log(selectMyReqs);1
  return <ReqCardsList reqs={selectMyReqs} />;
};

const mapStateToProps = createStructuredSelector({
  selectMyReqs: selectMyReqs,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMyReqsAsync: (x, y) => dispatch(fetchMyReqsAsync(x, y)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyReqsList);
